export const itemNames: Record<string, string> = {
	iname_Gold: "Cash",
	iname_Key: "Key",
	iname_Medikit: "Medikit",
	iname_PowerPlantKeyCard: "Power plant key card",
	iname_BaseKeyCard: "Base key card",
	iname_NightVisionEquipment: "Night vision equipment",
};
